<template>
    <div class="team-lawyer">
        <div class="title">
            团队律师
            <tip name="团队律师" demo-pic="https://lvlin-base.cdn.bcebos.com/bend/lawyer-demo.png"/>
        </div>
        <div class="operate">
            <veui-tabs
                ui="l"
                :active.sync="active"
                @change="tabChange"
            >
                <veui-tab
                    :label="'已展示'"
                    name="show"
                />
                <veui-tab
                    :label="'未展示'"
                    name="notShow"
                />
            </veui-tabs>
            <veui-button
                v-if="!total"
                ui="primary"
                type="button"
                class="add-btn"
                @click="goLayerList"
            >
                添加团队律师
            </veui-button>
        </div>
        <!-- 表格 -->
        <article :class="curData.length > 0 ? 'table' : 'table no-data'">
            <veui-table
                ui="l"
                key-field="id"
                role="columnheader"
                :data="curData"
                :loading="loading"
            >
                <veui-table-column
                    v-if="active === 'show'"
                    field="showIndex"
                    title="展示顺序"
                    align="center"
                    width="120"
                />
                <veui-table-column
                    field="layerInfo"
                    title="律师信息"
                    align="center"
                    width="200"
                >
                    <template #default="{name, personalAvatar}">
                        <div class="layer-info">
                            <img class="avatar" :src="personalAvatar"/>
                            <div class="name">{{ name }}</div>
                        </div>
                    </template>
                </veui-table-column>
                <veui-table-column
                    field="interveneYears"
                    title="从业年限"
                    align="center"
                    width="200"
                />
                <veui-table-column
                    field="registerDomain"
                    title="擅长领域"
                    align="center"
                >
                </veui-table-column>
                <veui-table-column
                    field="operation"
                    title="操作"
                    align="center"
                    width="200"
                >
                    <template #default="{uk, show, infoStatus, enableVip}">
                        <veui-button
                            ui="text"
                            class="operation-btn"
                            @click="changeState(uk, show ? 0 : 1, infoStatus)"
                        >
                            {{ show ? '下线' : '上线' }}
                        </veui-button>
                        <veui-button
                            v-if="active === 'show' && +enableVip === 0"
                            ui="text"
                            class="operation-btn"
                            @click="toTop(uk)"
                        >
                            置顶
                        </veui-button>
                    </template>
                </veui-table-column>

                <template #no-data>
                    <div v-if="!loading" class="blank">
                        <div class="icon"></div>
                        <div class="text">暂无律师记录</div>
                    </div>
                </template>
            </veui-table>
        </article>
        <!-- 分页 -->
        <article v-if="curData && curData.length" class="pagination">
            <veui-pagination
                :page="page"
                :page-size="pageSize"
                :total="count"
                @redirect="pageChange"
            />
        </article>
    </div>
</template>

<script>
/**
 * @file team-lawyer.vue
 * @author dingzhenyue
 * @desc 团队律师
 */
import {
    Tabs,
    Tab,
    Table,
    Column,
    Button,
    Pagination
} from 'veui';
import {mapState} from 'vuex';
import tip from '@/components/firm/tip';
export default {
    name: 'team-layer',
    components: {
        'veui-tabs': Tabs,
        'veui-tab': Tab,
        'veui-table': Table,
        'veui-table-column': Column,
        'veui-button': Button,
        'veui-pagination': Pagination,
        tip
    },
    data() {
        return {
            // 当前展示的tab
            active: 'notShow',
            // 当前展示的律师信息
            curData: [],
            // 每页个数
            pageSize: 10,
            // 当前展示第几页
            page: 1,
            // 当前tab下的总数
            count: 0,
            // 总数
            total: 0,
            // 表格加载
            loading: true,
            // 提交加锁
            isSubmit: false
        };
    },
    created() {
        this.getData();
    },
    computed: {
        ...mapState({
            businessId: state => state.lawStore?.userInfoNew?.law_business_info?.id || 0
        })
    },
    methods: {

        /**
         * 跳转律师列表
         */

        goLayerList() {
            this.$router.push({path: '/memberManage'});
        },

        /**
         * 切换tab
         *
         * @param {object} tab 选中的tab信息
         */

        tabChange(tab) {
            this.getData();
            this.page = 1;
        },

        /**
         * 改变上下线状态
         *
         * @param {string} uk 律师的uk
         * @param {string} show 上线：1，下线0
         * @param {string} infoStatus 律师的审核状态
         */
        changeState(uk, show, infoStatus) {
            // 未审核通过的律师不能上线
            if (show === 1 && +infoStatus !== 4) {
                this.$toast.error('该律师暂未通过律师审核，请通过审核后再行上线');
                return;
            }
            if (this.isSubmit) {
                return;
            }
            this.isSubmit = true;
            // 请求接口并刷新列表
            this.$http.post('/bp/api/business/optlawyer', {
                businessId: this.businessId,
                uk,
                show
            }).then(res => {
                this.isSubmit = false;
                let opeName = show === 1 ? '上线' : '下线';
                if (!res || +res.code !== 0) {
                    this.$toast.error(opeName + '失败，请稍候再试');
                    return;
                }
                opeName === '上线'
                    ? this.$toast.success(opeName + '成功，律师将于3小时后在律师主页及搜索结果中展现')
                    : this.$toast.success(opeName + '成功');
                this.getData();
            }).catch(err => {
                this.$normalizeResponseError(err);
                this.isSubmit = false;
            });
        },
        /**
         * 置顶
         */
        toTop(uk) {
            if (this.isSubmit) {
                return;
            }
            this.isSubmit = true;
            this.$http.post('/bp/api/business/toplawyer', {
                businessId: this.businessId,
                uk
            }).then(res => {
                this.isSubmit = false;
                if (res && +res.code === 0) {
                    this.$toast.success('置顶成功');
                    // 刷新列表
                    this.getData();
                    return;
                }
                this.$toast.success('置顶失败，请稍候再试');
            }).catch(err => {
                this.isSubmit = false;
                this.$toast.success('置顶失败，请稍候再试');
            });
        },

        /**
         * 翻页时更新数据
         *
         * @param {number} pn 第几页
         */

        pageChange(pn) {
            this.page = pn;
            this.getData();
        },

        /**
         * 获取律师数据
         */
        getData() {
            this.loading = true;
            this.$http.get('/bp/api/business/getlawyerlist', {
                params: {
                    businessId: this.businessId,
                    pn: this.page,
                    rn: this.pageSize,
                    show: this.active === 'show' ? 1 : 0
                }
            }).then(res => {
                this.loading = false;
                if (!res || +res.code !== 0 || !res.data) {
                    return;
                }
                let {list, count, total} = res.data || {};
                list.map((item, index) => {
                    return item.showIndex = this.pageSize * (this.page - 1) + index + 1;
                });
                this.curData = list || [];
                this.total = total;
                this.count = count;
            }).catch(err => {
                this.$normalizeResponseError(err);
                this.loading = false;
            });
        }
    }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/law-table.less";

.team-lawyer {
    background: #fff;
    padding: 19px 30px 30px;

    .title {
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #000;
        font-weight: 500;
        display: flex;
        line-height: 1;
        align-items: center;
        padding-bottom: 20px;
        position: relative;
        height: 40px;
        box-sizing: content-box;

        .tip {
            margin-left: 6px;
        }
    }

    .operate {
        position: relative;
        border-bottom: 1px solid #e9ecf3;
        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #333;
        font-weight: 500;

        .add-btn {
            position: absolute;
            top: -20px;
            right: 0;
            margin-right: 30px;
            background: #05f;
            border-radius: 5px;
            font-size: 16px;
            color: #fff;
            height: 40px;
        }
    }

    .operation-btn {
        color: #3855d5;
    }

    .table {
        margin-top: 30px;

        .layer-info {
            display: flex;
            align-items: center;

            .avatar {
                height: 40px;
                width: 40px;
                border-radius: 50%;
                margin-right: 10px;
            }
        }

        &.no-data {
            /deep/ .veui-table {
                border-bottom: none;
            }
        }
    }

    .pagination {
        text-align: right;
        padding: 30px 30px 0;
    }

    .blank {
        text-align: center;
        padding-bottom: 40px;

        .icon {
            height: 180px;
            width: 200px;
            background: url("https://lvlin-base.cdn.bcebos.com/bend/no-data.png") no-repeat center center;
            background-size: cover;
        }

        .text {
            margin-top: 12px;
            color: #333335;
        }
    }
}
</style>